import * as types from "./actionTypes";

export const remove = (id, {goBack = false}) => {
  return {
    type: types.API_REMOVE_TRANSFER_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = (data, deletedItemId) => {
  return {
    type: types.API_REMOVE_TRANSFER_SUCCESS,
    payLoad: { data, deletedItemId }
  };
};
export const removeFailure = (data, deletedItemId) => {
  return {
    type: types.API_REMOVE_TRANSFER_FAILURE,
    payLoad: { data, deletedItemId }
  };
};

export const store = (data, files) => {
  return {
    type: types.STORE_TRANSFER_REQUEST,
    data: data,
    files: files
  };
};
export const storeSuccess = () => {
  return {
    type: types.STORE_TRANSFER_SUCCESS
  };
};
export const storeFailure = () => {
  return {
    type: types.STORE_TRANSFER_FAILURE
  };
};
export const getRequest = id => {
  return {
    type: types.GET_TRANSFER_REQUEST,
    id
  };
};
export const getSuccess = data => {
  return {
    type: types.GET_TRANSFER_SUCCESS,
    payLoad:data
  };
};
export const getFailure = () => {
  return {
    type: types.GET_TRANSFER_FAILURE
  };
};

export const updateRequest = (id,data,files) => {
  return {
    type: types.UPDATE_TRANSFER_REQUEST,
    id,
    data,
    files
  };
};
export const updateSuccess = data => {
  return {
    type: types.UPDATE_TRANSFER_SUCCESS,
    payLoad:data
  };
};
export const updateFailure = () => {
  return {
    type: types.UPDATE_TRANSFER_FAILURE
  };
};